import React, { useEffect, useState } from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import Panel from 'Components/Panel/Panel';
import { format, setMinutes, setSeconds } from 'date-fns';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './Panels.css';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import BalancingDay from 'pages/Production/BalancingDay/BalancingDay';
import Button from 'Components/Button/Button';
import NoDataFolder from "../../Components/SideBar/assets/icons/no-data-folder.png"

const Panels = () => {
    const [currentDate, setCurrentDate] = useState(setSeconds(setMinutes(new Date(), 0), 0));
    const [productions, setProductions] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showQuantityProducedPiecesPanel, setShowQuantityProducedPiecesPanel] = useState(null);

    const fetchProductions = () => {
        const parameters = {
            selectedDay: currentDate
        }
        ExecuteAxios.api('get', `/production/get-list-productions-by-selected-day/`, { params: parameters }).then(response => {
            setProductions(response);
            setCurrentIndex(0);
        });
    };

    useEffect(() => {
        fetchProductions();

        const interval = setInterval(() => {
            fetchProductions();
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [currentDate]);

    const handlePrevDay = () => {
        setCurrentDate(prev => {
            const newDate = new Date(prev);
            newDate.setDate(newDate.getDate() - 1);
            return newDate;
        });
    };

    const handleNextDay = () => {
        setCurrentDate(prev => {
            const newDate = new Date(prev);
            newDate.setDate(newDate.getDate() + 1);
            return newDate;
        });
    };

    const handlePrevProduct = () => {
        setCurrentIndex(index => Math.max(index - 1, 0));
    };

    const handleNextProduct = () => {
        setCurrentIndex(index => Math.min(index + 1, productions.length - 1));
    };

    const styleQuantityProcedPiecesButton = {
        width: '85px',
        margin: '10px 15px 10px 0px',
        float: 'right',
        color: productions.length > 0 ? 'green' : '#201b2387',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '40px',
        fontSize: '1em'
    };

    return (
        <LayoutDefault>
            <Panel className={'main-modal'}>
                <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column' }}>
                    <div className='panels-header' style={{ display: 'flex', width: '100%', height: '10%', flexDirection: 'column' }}>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div style={{ alignContent: 'center', marginLeft: '20px', display: 'flex', width: '90%', flexDirection: 'row' }} >
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <button onClick={handlePrevDay} style={{ border: 'none', backgroundColor: 'transparent', fontSize: '1.2em' }}>
                                            <FiChevronLeft />
                                        </button>
                                        <div>
                                            {format(currentDate, 'dd/MM/yyyy')}
                                        </div>
                                        <button onClick={handleNextDay} style={{ border: 'none', backgroundColor: 'transparent', fontSize: '1.2em' }}>
                                            <FiChevronRight />
                                        </button>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <button onClick={handlePrevProduct} style={{ border: 'none', backgroundColor: 'transparent', fontSize: '1.2em' }}>
                                            <FiChevronLeft />
                                        </button>
                                        <span style={{ margin: '0 10px' }}>
                                            {(productions && productions.length > 0) ? currentIndex + 1 : 0}/{productions.length}
                                        </span>
                                        <button onClick={handleNextProduct} style={{ border: 'none', backgroundColor: 'transparent', fontSize: '1.2em' }}>
                                            <FiChevronRight />
                                        </button>
                                    </div>
                                </div>
                                <div className='panels-product-name' style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    fontSize: '50px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    flex: 1,
                                }}>
                                    {
                                        productions.length > 0
                                            ? productions[currentIndex]?.dsProduct || 'Produto sem descrição'
                                            : 'Nenhum produto encontrado.'
                                    }
                                </div>

                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button
                                    clickMethod={() => { setShowQuantityProducedPiecesPanel(true); }}
                                    buttonName={'Quantidade de peças'}
                                    style={styleQuantityProcedPiecesButton}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', width: '100%', height: '90%' }}>
                        {
                            productions.length > 0
                                ?
                                <BalancingDay
                                    productionDaysIdSelecteds={productions[currentIndex]?.productDayId}
                                    onUpdateReloadProductionList={() => { }}
                                    onUpdateDecreaseProductionPanelDay={() => { }}
                                    decreaseProductionPanelDay={true}
                                    mainPanel={false}
                                    showQuantityProducedPiecesPanelHelper={showQuantityProducedPiecesPanel}
                                    onUpdateShowQuantityProducedPiecesPanelHelper={setShowQuantityProducedPiecesPanel}
                                />
                                :
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    width: '100%',
                                    height: 'calc(100% - 37.6px)'
                                }}>
                                    <img src={NoDataFolder} alt="Sem dados" style={{
                                        width: '125px',
                                        marginBottom: '20px'
                                    }} />
                                    <span style={{
                                        fontSize: '1.2rem',
                                        color: '#555'
                                    }}>Nenhum produto encontrado.</span>
                                </div>
                        }
                    </div>
                </div>
            </Panel>
        </LayoutDefault >
    );
};

export default Panels;
